import { useEffect, useState } from "react";

import { getTickets } from "@api/e-tickets/tickets";
import { PaginationRequestType } from "@type/HRM/pagination";

export const useTickets = (url?: string) => {
  const [data, setData] = useState<any>({});
  const [query, setQuery] = useState<PaginationRequestType>({
    page: 1,
    size: 10,
  });

  const handleQuery = (key: string, value: number | string | null) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    getTickets(query, url)
      .then((data) => setData(data))
      .catch((err) => console.log(err));

    return setData({});
  }, [query]);

  return { data: data.data, pagination: data.pagination, handleQuery };
};
